import { Box } from '@mui/material';
import { UI_DIMENSIONS } from '../constants/uiConstants';

interface HeatmapLegendProps {
  legendUrl: string | null;
  position?: 'bottom-left' | 'bottom-right' | 'top-left' | 'top-right';
}

/**
 * Component to display heatmap legend image
 */
const HeatmapLegend = ({
  legendUrl,
  position = 'bottom-right',
}: HeatmapLegendProps) => {
  if (!legendUrl) {
    return null;
  }

  const positionStyles = {
    'bottom-left': { bottom: 16, left: 16 },
    'bottom-right': { bottom: 16, right: 16 },
    'top-left': { top: 16, left: 16 },
    'top-right': { top: 16, right: 16 },
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        ...positionStyles[position],
        zIndex: 1000,
        backgroundColor: 'background.paper',
        borderRadius: 1,
        boxShadow: 2,
        width: UI_DIMENSIONS.HEATMAP_LEGEND_WIDTH,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={legendUrl}
        alt="Heatmap legend"
        style={{
          width: `${UI_DIMENSIONS.HEATMAP_LEGEND_WIDTH}px`,
          objectFit: 'contain',
          display: 'block',
        }}
        onError={(e) => {
          console.error('Failed to load legend image:', legendUrl);
          (e.target as HTMLImageElement).style.display = 'none';
        }}
      />
    </Box>
  );
};

export default HeatmapLegend;
